<template>
  <!--顶部切换开始-->
  <div class="content-left-box fl"
       ref="leftTabBox"
       :class="resizeDrag?'ui-resizable':''"
       :style="{height:navHeight+'px',width:184 + 'px','flex-shrink': 0}"
       @contextmenu.stop.prevent="">
    <div class="arrow-box arrow-box-top"
         @click="changeLeftFn">
      <img src="~@/assets/image/images/icons/icon_arrow_left.png" />
    </div>
    <div class="cut-normal"
         ref="scrollDom">
      <div class="searchLeft">
          <input type="text" placeholder="请输入关键字" v-model="word"  @keyup.enter="filterCon()">
          <span @click="filterCon()"></span>
      </div>
      <div class="right-left-tab cut-long120"
           :style="{height:`${tabCalc}px`,width:tabNav.length==0?`184px`:`auto`,marginTop:`${marginTop}px`}">
        <leftMenu :item="sub"
                  v-for="(sub,ind) in tabNav"
                  :key="ind"
                  :index="ind"
                  :blockData="blockData"
                  :finalSequence="finalSequence"></leftMenu>
      </div>
    </div>
    <div class="arrow-box arrow-box-bottom"
         @click="changeRightFn">
      <img src="~@/assets/image/images/icons/icon_arrow_right.png" />
    </div>
    <div @click="handleStart"
         v-if="resizeDrag"
         class="ui-resizable-handle ui-resizable-e"
         style="z-index: 1000;"></div>
  </div>
  <!--顶部切换结束-->
</template>

<script>
// import $ from 'jquery'
import Bus from '../../../bus.js';
import ZImage from "../../ZImage.vue";
import leftMenu from './leftMenu.vue';
export default {
  name: "topTab",
  components: {
    ZImage,
    leftMenu
  },
  props: {
    finalSequence: Array,
    resizeDrag: {
      default: false
    },
    tabActiveType: {
      default: 'top',
      type: String
    },
    navHeight: {
      default: 425
    },
    nav: {
      default: () => ['个人', '企业', '商圈', '社会'],
      type: Array
    },
    tempNav: {
      default: () => ['个人', '企业', '商圈', '社会'],
      type: Array
    },
    refeshflag: {
      default: false,
      type: Boolean
    },
    title: {
      default: '',
      type: String
    },
    perNum: {
      default: 0,
      type: Number
    },
    blockData: {
      type: Object
    }
  },
  computed: {
    isPC () {
      if (window.innerWidth > 768) {
        return true;
      } else { return false; }
    }
  },
  data () {
    return {
      word:'',
      tabNav: [],
      ids: [],
      speed: 0,
      marginTop: 0,
      scrollHeight: 0,
      //刚改的
      tabCalc: 0
    }
  },
  //刚改的
  //跨级触发方法
  provide () {
    return {
      fatherMethod: this.tabSwitch,
      updateHeight: this.updateHeight,
      tabRight: this.tabRight,
    }
  },
  mounted () {
    this.tabNav = this.tempNav.filter((ite) => {
      if (this.$route.name == 'Next') {
        return ite.name ? ite.name : (ite.selectCircleName ? ite.selectCircleName : false)
      } else {
        return true;
      }
    });
    this.initFloorDrag();
  },
  watch: {
    'nav': function (list) {
      this.tabNav = [];
      var _this = this;
      this.$nextTick(() => {
        list.forEach((elm) => {
          if (elm.name) {
            _this.tabNav.push(elm);
          } else {
            _this.tabNav.push(elm);
          }
        });
      })
    },
    'refeshflag': function () {
      this.tabNav = this.tempNav.filter((ite) => {
        if (ite.name) {
          return ite.name
        }
        if (ite.selectCircleName) {
          return ite.selectCircleName
        }
        return false;
      });
    },
    //刚改的
    'tabNav': function (val) {
      if (val) {
        this.tabCalc = val.length * 61;
      }
    }
  },
  methods: {
    filterCon(){
      this.$emit('filterCons',this.word);
    },
    tabRight (item, ev) {
      //右键搜索功能所需参数
      window.$search = { item: item, area: 'left', floor: this.blockData.id };
      window.$nodeId = '';
      window.$floorflowId = this.blockData;
      window.$changeFlowBlock = item.flowType;
      if (item.flowType == "flow") {
        window.$floorId = item.id;
      } else if (item.flowType == "block") {
        window.$blockId = item.id;
      }
      if (item.nodeId) {
        window.$nodeId = item.nodeId;
      }
      Bus.$emit('windowRight', ev, item ,this.blockData.flowEnName);
    },
    //刚改的
    updateHeight (t) {
      //接受下级新增宽度或减少宽度
      this.tabCalc += t;
    },
    changeLeftFn () {
      if (this.speed == 0) {
        return false;
      }
      this.speed++;
      this.marginTop = this.speed * 150;
    },
    changeRightFn () {
      if (this.tabCalc + this.marginTop < this.$refs.scrollDom.clientHeight) {
        return false;
      }
      this.speed--;
      this.marginTop = this.speed * 150;
    },
    tabSwitch (item, n) {
      // if(n == 0){
      //     return false;
      // }

      var _this = this;
      if (item.name) {//流程选择
        if (!item.wzUrl) {
          if (item.flowType == 'flow') {
            // this.marginTop = 0;
            // this.speed = 0;
          }
          if (item.flowType == "standard") {
            return false;
          }
          this.$store.commit('setTopTabFlag', true);
          // this.$backArr.push(item);
          if(this.blockData.flowEnName == 'meta-universe'){
            this.$backArr.push({ 'item': item, 'obj': { refesh: true, activeTab: n, tabType: 'left' } });
          }
          this.$emit('changeTab', item, { refesh: true, activeTab: n, tabType: 'left' });
        } else {
          Bus.$emit('iframeOpen', 'toolsFrame', item.wzUrl,item.name);
        }
      } else {//选择商圈下的人员
        // this.$emit('changeCircle',item,n);item.types&&item.types=="showpaltform_circle"
        if (item.selectCircleName) {
          this.$blockGetData.handleCirclePerson(item).then(res => {
            _this.tabNav = res.data;
            _this.tabNav.unshift(item);
          });
        }
        if (item.photo) {
          this.$emit('changePerson', item);
        }
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.arrow-box {
  height: 30px;
  text-align: center;
  line-height: 31px;
  cursor: pointer;
  &:hover {
    background-color: #fafafa;
  }
  img {
    vertical-align: middle;
    transform: rotate(90deg);
  }
}
.arrow-box.arrow-box-top {
  border-bottom: 1px solid #ddd;
}
.arrow-box.arrow-box-bottom {
  border-top: 1px solid #ddd;
}
.content-left-box {
  width: 184px;
  position: relative;
  border-top: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  height: 488px;
  .cut-normal {
    margin-top: 38px;
    height: calc(100% - 100px);
    overflow: hidden;
    .searchLeft{
      position: absolute;
      top: 31px;
      width: 100%;
      height: 38px;
      padding: 4px 4px 5px;
      background-color: #ededed;
      box-sizing: border-box;
      input{
        width: 100%;
        height: 100%;
        border: none;
      }
      input::-webkit-input-placeholder{
        color:#bbb;
      }
      input:-moz-placeholder{
        color:#bbb;
      }
      input::-moz-placeholder.search-Box{
        color:#bbb;
      }
      input::-ms-input-placeholder{
        color:#bbb;
      }
      span{
        position: absolute;
        top: 12px;
        right: 14px;
        display: block;
        width: 14px;
        height: 14px;
        cursor: pointer;
        background: url("../../../assets/images/icons/search_for_14.png") no-repeat;
      }
    }
  }
  .right-left-tab {
    overflow: hidden;
    // width: 184px;
    margin-bottom: 1px;
    transition: .3s all;
    .right-tab {
      position: relative;
      border-bottom: 1px solid #ddd;
      cursor: pointer;
      display: block;
      height: 60px;
      line-height: 61px;
      padding-left: 8px;
      font-size: 16px;
      &:hover {
        color: #0d78cf;
      }
      .photo {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: middle;
        margin-top: -3px;
        padding-right: 5px;
        display: inline-flex;
      }
      .photo > .z-image {
        /deep/ .el-image__inner {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
      }
      .first {
        background-color: #f30101;
        color: #ffffff;
        font-weight: bold;
        height: 12px;
        line-height: 12px;
        border-radius: 4px;
        padding: 1px 3px;
        font-size: 12px;
      }
    }
    .right-tab.curr {
      position: relative;
      border-left: 1px solid #0d78cf;
      color: #0d78cf;
    }
    .right-tab.color-blue {
      color: #0d78cf;
    }
    .right-tab.main {
      font-weight: bold;
      color: #0d78cf;
    }
    .right-tab.main.curr {
      font-weight: bold;
    }
  }
}
.content-left-box .right-left-tab .right-tab .text {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
/* @media screen   and (max-width: 768px) {  
    .arrow-box-bottom{position: absolute;bottom: 0; width: 100%;}
    .arrow-box{margin:0;}
    // .content-left-box .right-left-tab{width:150px;}
    .content-left-box .cut-normal{width:150px;}
    .content-left-box .right-left-tab .right-tab{font-size:14px;}
    .content-left-box .right-left-tab .right-tab .text{width:126px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;display: inline-block;}
    .content-left-box .right-left-tab .right-tab,.arrow-box,
    .content-left-box .right-left-tab,.content-left-box,.content-left-box{
        height:40px;line-height:40px;min-height:40px;
    }
    .content-left-box .right-left-tab .right-tab .first{top:6px;}
    .content-left-box .right-left-tab .right-tab.curr{height:36px;line-height:36px;min-height:36px;} */
@media screen   and (max-width: 768px) {
  .content-left-box {
    position: absolute;
    background: #fff;
    z-index: 9;
    border: 1px solid #dddddd;
  }
}

/* } */
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/control/leftTab.vue